module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "connect"
  }, [_c('div', {
    staticClass: "social-container"
  }, _vm._l((_vm.links), function(link, index) {
    return _c('a', {
      key: ("social-link-" + index),
      attrs: {
        "href": link.url
      }
    }, [_c('div', {
      staticClass: "social-link"
    }, [_c('img', {
      attrs: {
        "src": _vm.fullImgPath(link.label),
        "alt": link.label
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "social-description"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(link.description) + "\n\t\t\t\t")])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cd9ac0e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/Connect.vue
// module id = 112
// module chunks = 1